import { render, staticRenderFns } from "./AppSnackbar.vue?vue&type=template&id=656a1ce6&scoped=true"
import script from "./AppSnackbar.vue?vue&type=script&lang=js"
export * from "./AppSnackbar.vue?vue&type=script&lang=js"
import style0 from "./AppSnackbar.vue?vue&type=style&index=0&id=656a1ce6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a1ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VSnackbar})
